<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1">
              <router-link  to="/">{{$t("lawyerRequested.breadcrumb_1")}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">
              {{$t("nav.inviteFriends")}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-12">
            <errorAlert
              v-if="hasError"
              :alertMessage="message"
              :errorNumber="errorNumber"
            />
          </div>
        </div>

        <mainloader v-if="isLoading" />
        
        <div class="row pt-3" v-else>
          <div class="col text-center">
            <img src="/assets/images/icons/Frame_invite.png" class="max-60" alt="">
          </div>
          <div class="almarai-bold pt-3 text-center">
            {{$t('Invite_Friends')}} {{cost}} {{$t('invite_P')}}
          </div>
          <div class="almarai-bold pt-2 text-center">
            {{$t('invite_NewFriend')}}
          </div>
          <div class="almarai-bold text-center">
            {{$t('Real_EstateInvestment')}}
          </div>

          <div class="row pt-5">
            <div class="col-12 col-md-5">
              <a :href="'https://wa.me/?text=https://aqaralmuhaysini.com/register?f='+GET_USER_DATA.userCode+'br'+'تطبيق عقاري شامل 🏠 بيع وشراء عقار، إدارة الأملاك، صيانة المنازل، مدونات عقارية، وتوثيق العقود.'" target="_blank">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-auto button-center">
                        <img src="/assets/images/icons/img-7.png" class="max-40" alt="" /><br>
                      </div>
                      <div class="col content-center">
                        <div class="almarai-bold">
                          {{$t("shareInvitationLink")}}
                        </div>
                      </div>
                      <div class="col-auto button-center">
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "inviteFriends",
  data(){
    return{
      isLoading: false,
      hasError: true,
      errorNumber: null,
      message: "",
      userLang: "ar",
      cost: null,
    }
  },
  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },
  methods:{
    getaffiliateCost(){
      this.hasError = false;
      this.isLoading = true;
      this.$http.get('/api/users/affiliateCost').then(res =>{
        // console.log(res);
        this.cost = res.data.cost;
        this.isLoading = false;
      }).catch(err => {
        [this.message , this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.isLoading = false;
      })
    }
  },
  created(){
    this.getaffiliateCost();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>